import CheckoutSummaryPromos from './checkout-summary-promos';
import template from './templates/checkout-review-summary';
import { context as defaultContext } from './checkout-defaults';

export default class CheckoutReviewSummary extends CheckoutSummaryPromos.extendTemplate(template) {
    constructor($originEl, context) {
        context = { ...defaultContext, ...context };

        super($originEl, context);

        this.aria = false;
    }

    init() {
        super.init();

        this.renderLabelOverrides();
    }

    renderLabelOverrides() {
        this.$checkoutLabel.html(this.context.PlaceOrder);
    }
}
